import { FormatDateOptions } from 'react-intl'
import styled from 'styled-components'

import { useDateFormat } from '../../hooks/useDateFormat'

const StyledCell = styled.div`
  white-space: nowrap;
  vertical-align: 'top';
`

export type StyledDateCellProps = {
  value: string
  dateFormatOptions?: FormatDateOptions
}

export const StyledDateCell = ({ value, dateFormatOptions: formatOptions }: StyledDateCellProps) => {
  const { formatDate } = useDateFormat()

  return <StyledCell>{formatDate(value, formatOptions ?? { dateStyle: 'medium', timeStyle: 'short' })}</StyledCell>
}

// eslint-disable-next-line react/display-name
export const makeStyledDateCell = (dateFormatOptions?: FormatDateOptions) => (value: string) => {
  return <StyledDateCell value={value} dateFormatOptions={dateFormatOptions} />
}
